import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=bc8e74ec&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc8e74ec')) {
      api.createRecord('bc8e74ec', component.options)
    } else {
      api.reload('bc8e74ec', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=bc8e74ec&", function () {
      api.rerender('bc8e74ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aRjd10qCqZTs/JS/imageCarousel.vue"
export default component.exports